/*
  ensureHasMetamask
  if metamask is not installed ask them to install it
  July 29th 2022
  William Doyle
*/
export default function ensureHasMetamask(callback: Function): void {
  if (typeof (window as any).ethereum === 'undefined')
    callback()
}